const YourApproachToFoodWhenYouTravel = Object.freeze({
  STREET_FOOD_AND_CASUAL_SPOTS: 'street_food_and_casual_spots',
  LOCAL_FAVOURITES: 'local_favourites',
  NEW_AND_LIVELY_RESTAURANTS: 'new_and_lively_restaurants',
  SPECIAL_OCCASION_DINING: 'special_occasion_dining',
  FOOD_IS_NOT_A_PRIORITY: 'food_is_not_a_priority',

  // Retained so existing saved DNA remains valid.
  LOCAL_AND_AUTHENTIC: 'local_and_authentic',
  FINE_DINING: 'fine_dining',
  A_MIX_OF_LOCAL_AUTHENTIC_AND_FINE_DINING:
    'a_mix_of_local_authentic_and_fine_dining',
} as const);

export type YourApproachToFoodWhenYouTravel =
  (typeof YourApproachToFoodWhenYouTravel)[keyof typeof YourApproachToFoodWhenYouTravel];

export const allYourApproachToFoodWhenYouTravel: [
  YourApproachToFoodWhenYouTravel,
  ...YourApproachToFoodWhenYouTravel[],
] = Object.values(YourApproachToFoodWhenYouTravel) as [
  YourApproachToFoodWhenYouTravel,
  ...YourApproachToFoodWhenYouTravel[],
];

export default YourApproachToFoodWhenYouTravel;
